<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="mt-2 mx-0 border-none p-0">
      <b-card-header id="carstats-card-header" class="pl-2 pr-3 small">
        <b-row>
          <b-col>Car Stats</b-col>
          <b-col cols="12" md="5">
            <b-dropdown class="float-right" variant="transparent p-0" right>
              <template slot="button-content">
                <i class="icon-clock"></i>
              </template>
              <b-dropdown-item
                v-for="timerange in timeranges"
                :key="timerange"
                @click="handleUpdate(timerange)"
                >{{ timerange }}</b-dropdown-item
              >
            </b-dropdown>
            <div class="mb-0 text-right pr-4">In the last: {{ timerange }}</div>
          </b-col></b-row
        >
      </b-card-header>
      <b-tooltip target="carstats-card-header" triggers="hover"
        >Car Statistics</b-tooltip
      >

      <b-card-body class="px-0 pt-0">
        <b-row class="mt-3 h-90px px-3 text-center">
          <b-col
            cols="6"
            md="6"
            :id="stat.label"
            v-for="(stat, index) in items"
            :key="index"
            class="mb-3"
          >
            <i
              :class="
                'fa-' +
                stat.icon +
                ' fa bg-info p-4 font-2xl mr-3 float-left w-75px text-center'
              "
            ></i>
            <div class="h5 text-info mb-0 pt-3">{{ stat.value }}</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">
              {{ stat.label }}
            </div>
          </b-col>
          <!-- <b-tooltip
            v-for="(stat, tindex) in stats"
            :key="tindex"
            :target="stat.label"
            triggers="hover"
            >Number of {{ stat.label }}</b-tooltip
          > -->
        </b-row>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import moment from "moment";

export default {
  name: "CarStats",
  props: ["tile", "refresh"],
  data() {
    return {
      busy: false,
      timeout: false,
      name: "CarStats",
      timerange: "90 days",
      timeranges: ["30 days", "60 days", "90 days", "180 days", "365 days"],
      items: [],
    };
  },

  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    chartType() {
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "Table";
      }
    },
  },
  methods: {
    async loadChart() {
      console.log("loadChart: carstats", this.timerange);

      this.busy = true;

      let from = null;
      switch (this.timerange) {
        case "30 days":
          from = moment().add(-30, "days").format("YYYY-MM-DD");
          break;
        case "60 days":
          from = moment().add(-60, "days").format("YYYY-MM-DD");
          break;
        case "90 days":
          from = moment().add(-90, "days").format("YYYY-MM-DD");
          break;
        case "180 days":
          from = moment().add(-180, "days").format("YYYY-MM-DD");
          break;
        case "365 days":
          from = moment().add(-365, "days").format("YYYY-MM-DD");
          break;
      }

      let variables = {
        datepickupfrom: from,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query chart_carstats($datepickupfrom: String) {
              chart_carstats(datepickupfrom: $datepickupfrom) {
                datasets {
                  label: key
                  value
                }
              }
            }
          `,
          variables,
        });
        let data = response.data.chart_carstats.datasets;
        for (var i = 0; i < data.length; i++) {
          switch (data[i].label) {
            case "booked":
              data[i].icon = "car";
              break;
            case "events":
              data[i].icon = "calendar-check-o";
              break;
            case "clients":
              data[i].icon = "users";
              break;
            case "invoiced":
              data[i].icon = "gbp";
              break;
          }
        }
        this.items = data;
        console.log("stats array", data);
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
      await this.$emit("refreshed");
    },
    async handleUpdate(update) {
      console.log("handleUpdate", update);
      this.timerange = update;
      await this.loadChart();
    },
  },
};
</script>


<style>
</style>